export const FEATURE_PRODUCT_TOUR = 'product-tour-overview'
export const FEATURE_GUEST_APP = 'guest-app-onboarding'
export const FEATURE_CINDERELLA = 'cinderella'
export const FEATURE_COURSE_QUESTIONS = 'course-questions'
export const FEATURE_SCHEDULE_MOVE_IT = 'schedule-move-it'
export const FEATURE_COURSE_NAME = 'coursename-mui-259'
